import React from 'react'
import { connect } from 'react-redux'
import './index.scss'
import isNil from 'lodash/isNil'
import { openModal } from '../../../action/positioned-modal-state'
import { waitForGoogleMaps } from '../maploader/maploader'

let MapPopupClass;

waitForGoogleMaps(() => {
  MapPopupClass = class extends google.maps.OverlayView {
    constructor(position, content, type) {
      super()
      this.position = position
      content.classList.add('popup-bubble')
      // This zero-height div is positioned at the bottom of the bubble.
      this.content = content
      const bubbleAnchor = document.createElement('div')
      bubbleAnchor.classList.add('popup-bubble-anchor')
      if (type === 'friend') {
        bubbleAnchor.style.bottom = '36px'
      }
      bubbleAnchor.appendChild(this.content)
      // This zero-height div is positioned at the bottom of the tip.
      this.containerDiv = document.createElement('div')
      this.containerDiv.classList.add('popup-container')
      this.containerDiv.appendChild(bubbleAnchor)
      // Optionally stop clicks, etc., from bubbling up to the map.
      MapPopupClass.preventMapHitsAndGesturesFrom(this.containerDiv)
    }
    /** Called when the popup is added to the map. */
    onAdd() {
      this.getPanes().floatPane.appendChild(this.containerDiv)
    }
    /** Called when the popup is removed from the map. */
    onRemove() {
      if (this.containerDiv.parentElement) {
        this.containerDiv.parentElement.removeChild(this.containerDiv)
      }
    }
    /** Called each frame when the popup needs to draw itself. */
    draw() {
      const divPosition = this.getProjection().fromLatLngToDivPixel(
        this.position
      )
      // Hide the popup when it is far out of view.
      const display =
        Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
          ? 'block'
          : 'none'

      if (display === 'block') {
        this.containerDiv.style.left = divPosition.x + 'px'
        this.containerDiv.style.top = divPosition.y + 'px'
      }

      if (this.containerDiv.style.display !== display) {
        this.containerDiv.style.display = display
      }
    }
    setContent(content) {
      this.content = content
    }
  }
}
)

class MapPopup extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      featureIdx: 0,
      featureModal: null,
      errorMessage: ''
    }
  }

  componentDidMount() {
    try {
      if (this.state.featureModal === null) {
        const modal = new MapPopupClass(
          this.props.featureData.position,
          document.getElementById('map-popup-content'),
          this.props.featureData.type
        );
        modal.setMap(this.props.mapReference);
        this.setState({ featureModal: modal });
      }
    } catch (error) {
      this.setState({ errorMessage: "Unable to open the map popup. Please try again." });
      console.error("MapPopup error:", error); // Log the error for debugging
    }
  }

  componentWillUnmount() {
    this.state.featureModal.setMap(null)
  }

  nextFeature() {
    this.setState({ featureIdx: this.state.featureIdx + 1 })
  }

  previousFeature() {
    this.setState({ featureIdx: this.state.featureIdx - 1 })
  }

  makePopupContent() {
    const { featureData, featureFields, openModal } = this.props,
      { features } = featureData,
      data = features[this.state.featureIdx],
      fields = data.type === 'Feature' ? featureFields[data.layerInfo.id] : [],
      dataKeyValObj = Object.keys(data.properties).map(key => {
        const displayRule = fields && fields.find(field => field.fieldName === key);
        if (displayRule && displayRule.displayAs === 'hide') {
          return null;
        }
        let value = data.properties[key];
        if (displayRule) {
          if (!displayRule.decimalPoints) {
            switch (displayRule.displayAs) {
              case "number":
                value = Number(value).toLocaleString();
                break;
              case 'percent':
                value = `${Number(value).toLocaleString()}%`;
                break;
              case 'string':
                value = value;
                break;
              default:
                break;
            }
          }
          if (displayRule.decimalPoints) {
            if (!isNaN(value))
              value = Number(value).toLocaleString(undefined, { minimumFractionDigits: displayRule.decimalPoints, maximumFractionDigits: displayRule.decimalPoints });
          }
        }
        return { key: displayRule?.displayName || key, value: value };
      }).filter(Boolean),
      headerText = featureData.type === 'feature' ? `Layer: ${data.layerInfo.name}` : featureData.type === 'friend' ? data.name : ''

    const dataVal = features;

    // Deduplicate by "Usgs Quad Id"
    const seen = new Set();
    const unique = dataVal.filter(item => {
      const quadId = item.properties?.["Usgs Quad Id"]?.trim();
      if (!quadId) return true; // keep if no Usgs Quad Id field
      if (seen.has(quadId)) return false;
      seen.add(quadId);
      return true;
    });

    return (
      <div id='map-popup-content' style={this.props.featureData.transformStyle}>
        <div className='popup-header'>
          <div className='popup-header-text'>{headerText}</div>
          <div className='default-close popup-close' onClick={this.props.clearFeatureData}></div>
          <div className='popup-dot-container'>
            {unique.map((feature, idx) => {
              return (
                <div key={`popup-dot-${idx}`} className={`popup-dot ${idx === this.state.featureIdx ? 'popup-dot-active' : ''}`}></div>
              )
            })}
          </div>
        </div>
        <div className='popup-inner'>
          <div className='popup-left-bumper'
            onClick={this.previousFeature.bind(this)}
            style={{ visibility: this.state.featureIdx === 0 ? 'hidden' : '' }}></div>
          <div className='popup-feature-data'>
            {
              dataKeyValObj.map(item => {
                return item.key && item.value ? (
                  <div className='popup-data-entry' key={`popup-entry-${item.key}`}>
                    <p style={{ width: '25%' }}>{item.key.split('_').join(' ')}</p>
                    <p style={{ width: '75%' }}> : {item.value}</p>
                  </div>
                ) : null
              })
            }
            {
              isNil(data.harvest_data) ? null :
                (
                  <button
                    onClick={() => {
                      this.props.clearFeatureData()
                      openModal(data)
                    }}
                    style={{ backgroundColor: '#ff6800' }} >See Hunt Results</button>
                )
            }
          </div>
          <div className='popup-right-bumper'
            onClick={this.nextFeature.bind(this)}
            style={{ visibility: this.state.featureIdx === features.length - 1 ? 'hidden' : '' }}></div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div style={{ display: 'none' }}>
        {this.makePopupContent()}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  mapReference: state.mapReference(),
  featureFields: state.featureFields
})


const mapDispatchToProps = dispatch => ({
  openModal: data => dispatch(openModal(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(MapPopup)
